import {Component, OnInit} from '@angular/core';
import { AutoLogoutService } from '@app/services/auto-logout.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})

/**
 * The base component layout. Contains all other layout components
 */
export class LayoutComponent implements OnInit {

    constructor(private autoLogoutService: AutoLogoutService) {
    }

    ngOnInit() {
        this.autoLogoutService.initService();
    }
}
